







































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader } from '@/components';
import PickerInput from './components/PickerInput.vue';
import { Button, Dialog, Toast, Popup } from 'vant';
import { FileType } from '@/common/ts/enum';
import { save } from '@/api/api';
import { getTypes, getAreas, getSchools } from './api/index';
import * as config from './config';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
  },
})
export default class Uploading extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  schoolType = false;
  UploaderImg = true;
  UploaderText?: string = '';
  UploaderTips?: string = '';
  FileType = FileType;
  typePickerData: any[] = [];
  areasPickerData: any[] = [];
  schoolList: any[] = [];
  // 需要传的参数
  workType?: number; // 参与类型
  countryId?: number; // 区域id
  subtitle?: string = ''; // 姓名
  school?: string = ''; // 学校
  className?: string = ''; // 班级
  title?: string = ''; // 作品名称
  teacher?: string = ''; // 指导老师
  cover?: string = ''; // 照片/视频
  @Watch('school')
  onSchoolValueChanged(newVal: any, val: any) {
    if (newVal) {
      this.fetchSchoolData(newVal);
    }
  }
  created() {
    getTypes().then((res: any) => this.successTypesData(res));
    getAreas().then((res: any) => this.successAreasData(res));
  }
  // getContainer() {
  //   return document.querySelector('.schoolAll');
  // }
  successTypesData(res: any) {
    this.typePickerData = [
      '春节祝福（视频）',
      '春节味道（照片）',
      '春节景象（照片）',
    ];
  }
  successAreasData(res: any) {
    this.areasPickerData = Object.values(res.data);
  }
  fetchTypeData(e: string, index: number) {
    if (index === 0) {
      this.workType = 3;
    } else if (index === 1) {
      this.workType = 2;
    } else {
      this.workType = 1;
    }
    this.typeDataChange(index);
  }
  typeDataChange(index: number) {
    if (index === 0) {
      this.UploaderText = '竖视频';
      this.UploaderTips = '注：视频最多不超过60秒';
      this.UploaderImg = false;
    } else {
      this.UploaderText = '图片';
      this.UploaderTips = '注：请选择一张照片上传';
      this.UploaderImg = true;
    }
  }
  fetchAreasData(e: string, index: number) {
    this.countryId = index + 1;
  }
  fetchSchoolData(value: any) {
    this.schoolType = true;
    getSchools(value).then((res: any) => this.successSchoolData(res));
  }
  successSchoolData(res: any) {
    this.schoolList = res.data.map((schoolData: any) => schoolData.name);
    // console.log('res', res.data.map(schoolData => schoolData.name),this.schoolList);
  }
  chooseSchool(index: number, school: string) {
    this.school = school;
    this.schoolType = false;
  }
  getOssImagesUrls(result: any) {
    this.cover = result[0];
    console.log('result', result, this.cover);
  }
  getOssVideoUrls(result: any) {
    this.cover = result;
    console.log('result', result, this.cover);
  }
  enterSave() {
    if (!this.workType) {
      Toast.fail('请选择作品类型');
      return false;
    }
    if (!this.countryId) {
      Toast.fail('请选择区域');
      return false;
    }
    if (!this.subtitle) {
      Toast.fail('请填写姓名');
      return false;
    }
    if (!this.school) {
      Toast.fail('请填写学校');
      return false;
    }
    if (!this.className) {
      Toast.fail('请填写班级');
      return false;
    }
    if (!this.title) {
      Toast.fail('请填写作品名称');
      return false;
    }
    if (!this.teacher) {
      Toast.fail('请填写指导老师');
      return false;
    }
    if (!this.cover) {
      Toast.fail('请上传' + this.UploaderText);
      return false;
    }
    save(this.options.voteName, {
      work_type: this.workType,
      country_id: this.countryId,
      subtitle: this.subtitle,
      school: this.school,
      class: this.className,
      title: this.title,
      teacher: this.teacher,
      cover: this.cover,
    }).then((res: any) => this.successSave(res));
  }
  successSave(res: any) {
    if (res.code === 101) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.go(0);
      }, 3000);
    } else if (res.code === 203) {
      Toast.fail('请登录后再访问！');
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
